import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformExternalReference } from './external-reference.transform';
import type { ExternalReferenceCollection } from './external-reference.types';

export function externalReferenceReducer(
  state: CollectionStateSlice<ExternalReferenceCollection> = {},
  action: CollectionActions<ExternalReferenceCollection>,
): CollectionStateSlice<ExternalReferenceCollection> {
  switch (action.type) {
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'externalReference') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<ExternalReferenceCollection>(
          state,
          transformIntoDocuments([result], transformExternalReference),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'externalReference') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<ExternalReferenceCollection>(
          state,
          transformIntoDocuments([result], transformExternalReference),
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'externalReference') {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById<ExternalReferenceCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }
      return state;
    }

    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'externalReference') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<ExternalReferenceCollection>(
          state,
          transformIntoDocuments(result, transformExternalReference),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
